module.exports = __webpack_public_path__ + "static/media/background.8f8eea72.png";